import { render, staticRenderFns } from "./way.vue?vue&type=template&id=1036ae90&scoped=true&"
import script from "./way.vue?vue&type=script&lang=js&"
export * from "./way.vue?vue&type=script&lang=js&"
import style0 from "./way.vue?vue&type=style&index=0&id=1036ae90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036ae90",
  null
  
)

export default component.exports